import { useCallback } from 'react'
import { proxy, useSnapshot } from 'valtio'
import { DrawType } from './const'
import {  SizeType } from '@/constants'

const defaultState: platformState = {
  taskId: undefined,
  taskItemIds: undefined,
  isCreating: false,
  createType: DrawType.productMainImage,
  tempActiveStyle: void 0,
  styleTemplateName: '',
  conditions: {
    width: 1024,
    height: 1024,
    styleTemplateId: void 0,
    aspectRatioId:SizeType.手机海报,
    conditionType: 'intellect',
    posterImageUrl: '',
    posterCaseId: void 0,
    randomStyle: false,
    background: void 0,
    onceNumber: 2,
    industryTagId:void 0,
    templateId: void 0,
  },
  broadcastMessage: undefined,
  preview: [],
  copyItemId: 0,
  templateId: 0,
  copyClickNum: 0,
  isEdit: false,
  costExpand: [],
  curImageCaption:'',
  tourOpen:false,
  isLoadingCopy:true,
  ratioList:[],
  goodsName:'',
  goodsFeature: [],
  // 图片说明
  imgCaptionRephrase: '',
  sourceImageUrls: [],
  isModelUpdating:false,
  downloadId: undefined,
  textRequire: '',
  isDownload: false,
  targetLanguage: 'zh',
  oldCanvasData:[],
  isWriteWithTargetLanguage: false,
  sceneTagList:[],
  sceneTagId:null,
  sceneScale: 1,
  isSaving:false,
  isLoading:false,
  hasHistory:false,
  hasMore:false,
  tempTemplateId:void 0,
}

export const PlatformState = proxy({
  ...defaultState,
    // 排队中队列
    get isLineUpList() {
      // @ts-ignore
      return this?.preview
        ?.filter((i: preivewItem) => i?.isLineUp>1)
        .map((i: preivewItem, index: number) => ({
          itemId: i.itemId,
          isLineup:i.isLineUp
        }))
    },
})

export const initPlatformStore = (data?: any) => {
  Object.assign(PlatformState, defaultState, data)
}

export const usePlatform = () => {
  const snap = useSnapshot(PlatformState)
  const updatePlatformAll = useCallback(
    (callBack: any) => {
      callBack(PlatformState)
    },
    [snap],
  )
  return {
    // render时使用
    snap,
    // state可直接修改
    state: PlatformState,
    updatePlatformAll,
  }
}
